import { z } from 'zod';

/**
 * Unified AIMLAPI error schema.
 * Minimum required fields compatible with createJsonErrorResponseHandler<T>.
 */
export const aimlapiErrorSchema = z.object({
  error: z.object({
    message: z.string(),
    code: z.string().optional(),
    type: z.string().optional(),
  }),
});

export type AIMLAPIErrorData = z.infer<typeof aimlapiErrorSchema>;
